var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiStarsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "stars",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.568,
    height: 24.754,
    viewBox: "0 0 18.568 24.754",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.151,
    x2: 1.317,
    y2: 0.88,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ac52ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3076f7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40358",
    "data-name": "Group 40358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59915",
    "data-name": "Path 59915",
    d: "M13.3,9.667a.559.559,0,0,1,1.061,0l1,3a4.471,4.471,0,0,0,2.83,2.828l3,1a.559.559,0,0,1,0,1.061l-3,1a4.471,4.471,0,0,0-2.828,2.83l-1,3a.559.559,0,0,1-1.061,0l-1-3A4.471,4.471,0,0,0,9.472,18.55l-3-1a.559.559,0,0,1,0-1.061l3-1A4.471,4.471,0,0,0,12.3,12.664l1-3ZM7.322,1.778a.336.336,0,0,1,.637,0l.6,1.8a2.686,2.686,0,0,0,1.7,1.7l1.8.6a.336.336,0,0,1,0,.637l-1.8.6a2.683,2.683,0,0,0-1.7,1.7l-.6,1.8a.336.336,0,0,1-.637,0l-.6-1.8a2.683,2.683,0,0,0-1.7-1.7l-1.8-.6a.336.336,0,0,1,0-.637l1.8-.6a2.683,2.683,0,0,0,1.7-1.7ZM18.258.155a.224.224,0,0,1,.424,0l.4,1.2a1.787,1.787,0,0,0,1.133,1.133l1.2.4a.224.224,0,0,1,0,.424l-1.2.4A1.789,1.789,0,0,0,19.082,4.84l-.4,1.2a.224.224,0,0,1-.424,0l-.4-1.2a1.789,1.789,0,0,0-1.133-1.133l-1.2-.4a.224.224,0,0,1,0-.424l1.2-.4a1.787,1.787,0,0,0,1.133-1.133l.4-1.2Z",
    transform: "translate(-2.998 -0.004)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiStarsIcon);
export default __webpack_public_path__ + "static/media/ai_stars-icon.cf0520407f537e373e51482c3bca457d.svg";
export { ForwardRef as ReactComponent };